module.exports = __webpack_public_path__ + "img/exit_7.870ff684.svg";